import * as MUTATION from "@/store/mutation-types";

const state = {
  form_info: {
    parent_id: null,
  },
  show_access_message: true
};

const getters = {
  formInfo: state => state.form_info,
  parentId: state => state.form_info.parent_id,
  showAccessMessage: state => state.show_access_message
};

const mutations = {
  ACCESS_MESSAGE_TOGGLE: state => {
    state.show_access_message = !state.show_access_message
  }, 
  PARENT_ID_UPDATE: (state, { parent_id }) => {
    state.form_info.parent_id = parent_id;
  }
};

const actions = {
  TOGGLE_ACCESS_MESSAGE: ({ commit }) => {
    commit(MUTATION.ACCESS_MESSAGE_TOGGLE);
  },
  UPDATE_PARENT_ID: ({ commit }, data) => {
    commit(MUTATION.PARENT_ID_UPDATE, data);
  }
};

export default {
  getters,
  mutations,
  actions,
  state
};
